"use client";

import { ThemeSwitch } from "@components/ui/theme-switch";
import { LanguagePicker } from "@components/ui/language-picker";

export function AuthControls() {
  return (
    <div className="flex items-center gap-2">
      <LanguagePicker />
      <ThemeSwitch />
    </div>
  );
}
